import SessionStorage from '@/services/session-storage'
import {Jwt} from '@/services/resources'
import miniToastr from 'mini-toastr'

export default {
  get perfil () {
    return SessionStorage.get('perfil')
  },
  set perfil (value) {
    SessionStorage.set('perfil', value)
  },
  get token () {
    return SessionStorage.get('token')
  },
  set token (value) {
    SessionStorage.set('token', value)
  },
  get usuario () {
    return SessionStorage.get('usuario')
  },
  set usuario (value) {
    SessionStorage.set('usuario', value)
  },
  get permissoes () {
    return SessionStorage.get('permissoes')
  },
  set permissoes (value) {
    SessionStorage.setObject('permissoes', value)
  },
  get tipoPerfil () {
    return SessionStorage.get('tipoPerfil')
  },
  set tipoPerfil (value) {
    SessionStorage.setObject('tipoPerfil', value)
  },
  accessToken (data) {
    return Jwt.accessToken(data).then((response) => {
      if (response.body.success) {
        this.token = response.body.data.token
        this.perfil = response.body.data.perfil
        this.usuario = response.body.data.user
        this.permissoes = response.body.data.permissoes[0].permissoes
        this.tipoPerfil = response.data.data.permissoes[0].tipo_perfil
      } else {
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error(response.body.msg, 'Erro:', 5000)
      }
    })
  },
  refreshToken () {
    return Jwt.refreshToken().then(response => {
      this.token = response.data.token
      return response
    })
  },
  getAuthorizationHeader () {
    return `Bearer ${this.token}`
  }
}



// WEBPACK FOOTER //
// ./src/services/jwt-token.js